module.exports = __webpack_public_path__ + "img/bkk-logo.42e789b7.svg";